module.exports = __webpack_public_path__ + "media/images/paypal-payment-a78fdd2dacd8d0f7a0d4bf155c505c9b.svg";